import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import BloodRequests from './pages/BloodRequests';
import DonationCenters from './pages/DonationCenters';
import OrganDonation from './pages/OrganDonation';
import Regulations from './pages/Regulations';
import RegulationDetail from './pages/RegulationDetail';
import GlobalMap from './pages/GlobalMap';
import AdminPortal from './pages/AdminPortal';
import MyProfile from './pages/MyProfile';
import EditProfile from './pages/EditProfile';
import MyNetwork from './pages/MyNetwork';
import DigitalBadge from './pages/DigitalBadge';
import SponsorsMedia from './pages/SponsorsMedia';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import AccessibilityPolicy from './pages/AccessibilityPolicy';
import CenterAdminPortal from './pages/CenterAdminPortal';
import Register from './pages/Register';
import EmailVerification from './pages/EmailVerification';
import SignIn from './pages/SignIn';
import ThankYou from './pages/ThankYou';
import NotFound from './pages/NotFound';
import ScrollToTop from './components/ScrollToTop';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';
import { Toaster as UseToastToaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <ScrollToTop />
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="register" element={<Register />} />
              <Route path="signin" element={<SignIn />} />
              <Route path="thank-you" element={<ThankYou />} />
              <Route path="verify-email/:token" element={<EmailVerification />} />
              <Route path="blood-requests" element={<BloodRequests />} />
              <Route path="donation-centers" element={<DonationCenters />} />
              <Route path="center-portal" element={<CenterAdminPortal />} />
              <Route path="organ-donation" element={<OrganDonation />} />
              <Route path="regulations" element={<Regulations />} />
              <Route path="regulations/:countryCode" element={<RegulationDetail />} />
              <Route path="global-map" element={<GlobalMap />} />
              <Route path="admin" element={<AdminPortal />} />
              <Route path="profile" element={<MyProfile />} />
              <Route path="profile/edit" element={<EditProfile />} />
              <Route path="network" element={<MyNetwork />} />
              <Route path="badge" element={<DigitalBadge />} />
              <Route path="partners" element={<SponsorsMedia />} />
              <Route path="privacy" element={<PrivacyPolicy />} />
              <Route path="terms" element={<TermsOfUse />} />
              <Route path="accessibility" element={<AccessibilityPolicy />} />
              <Route path="*" element={<NotFound />} />
            </Route>
        </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster />
      <UseToastToaster />
    </div>
  );
}

export default App;